import { render, staticRenderFns } from "./PickContactModal.vue?vue&type=template&id=5ecc0d4d&scoped=true"
import script from "./PickContactModal.vue?vue&type=script&lang=ts"
export * from "./PickContactModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc0d4d",
  null
  
)

export default component.exports